<template>
    <div>
        <h3 v-if="dados">{{ dados.length }} {{ aba }}</h3>
    </div>
</template>
<script>
export default {
    props: ["dados", "aba"]
};
</script>
